import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

const ProtectedUserRoutes = React.lazy(() => import("./ProtectedUserRoutes"));
const ProtectedAdminRoutes = React.lazy(() => import("./ProtectedAdminRoutes"));

const Drops = React.lazy(() => import("../pages/user/drops/Drops"));
const Records = React.lazy(() => import("../pages/user/records/Records"));
const Payment = React.lazy(() => import("../pages/user/payment/Payment"));
const Contact = React.lazy(() => import("../pages/user/contacts/Contact"));
const Overview = React.lazy(() => import("../pages/user/overview/Overview"));
const Accounts = React.lazy(() => import("../pages/admin/account/Accounts"));
const UserProfile = React.lazy(() => import("../pages/user/profile/UserProfile"));
const OrderFuel = React.lazy(() => import("../pages/user/order-fuel/OrderFuel"));
const AdminProfile = React.lazy(() => import("../pages/admin/profile/AdminProfile"));
const UserAccounts = React.lazy(() => import("../pages/user/accounts/UserAccounts"));
const Register = React.lazy(() => import("../pages/un-authorised/register/Register"));
const PageNotFound = React.lazy(() => import("../pages/page-not-found/PageNotFound"));
const ListUsers = React.lazy(() => import("../pages/admin/users/list-users/ListUsers"));
const Inquiries = React.lazy(() => import("../pages/admin/account/inquiries/Inquiries"));
const FuelOrder = React.lazy(() => import("../pages/admin/account/fuel-order/FuelOrder"));
const ChangePassword = React.lazy(() => import("../pages/change-password/ChangePassword"));
const CreateUser = React.lazy(() => import("../pages/admin/users/create-user/CreateUser"));
const VerifyEmail = React.lazy(() => import("../pages/un-authorised/register/VerifyEmail"));
const PayAsGuest = React.lazy(() => import("../pages/un-authorised/pay-as-guest/PayAsGuest"));
const LoginLayout = React.lazy(() => import("../pages/un-authorised/login-layout/LoginLayout"));
const NewCustomer = React.lazy(() => import("../pages/un-authorised/new-customer/NewCustomer"));
const ManageConfigs = React.lazy(() => import("../pages/admin/account/manage-configs/ManageConfigs"));
const ResetPassword = React.lazy(() => import("../pages/un-authorised/forget-password/ResetPassword"));
const AccountDetails = React.lazy(() => import("../pages/admin/account/account-details/AccountDetails"));
const ForgetPassword = React.lazy(() => import("../pages/un-authorised/forget-password/ForgetPassword"));
const ApplyForAccount = React.lazy(() => import("../pages/un-authorised/apply-for-account/ApplyForAccount"));
const ManageAppSetting = React.lazy(() => import("../pages/admin/account/manage-app-setting/ManageAppSetting"));
const CreditApplications = React.lazy(() => import("../pages/admin/account/credit-application/CreditApplications"));
const AccountApplications = React.lazy(() => import("../pages/admin/account/account-application/AccountApplications"));
const ResidentialApplication = React.lazy(() => import("../pages/user/residential-application/ResidentialApplication"));
const ManageContent = React.lazy(() => import("../pages/admin/account/manage-app-setting/manage-content/ManageContent"));
const PromotionalImages = React.lazy(() => import("../pages/admin/account/manage-app-setting/promotional-images/PromotionalImages"));
const NotificationConfigComponent = React.lazy(() => import("../pages/admin/account/manage-configs/notification-config/NotificationConfigComponent"));
const ViewPdf = React.lazy(() => import("../pages/user/records/documents/ViewPdf"));
const userInfo = sessionStorage.userInfo && JSON.parse(sessionStorage.userInfo);

export const routes: RouteObject[] = [
    {
        path: "/",
        children: [
            {
                path: "",
                element: (
                    userInfo?.user_key?.length ? (userInfo?.role !== "User" ? <Navigate to="/admin/accounts" replace /> : <Navigate to="/accounts" replace />) : <Navigate to="/login" replace />
                )
            },
            {
                path: 'password-reset/complete',
                element: <ResetPassword />,
            },
            {
                path: 'registration-confirm/complete',
                element: <VerifyEmail />,
            },
            {
                path: "register",
                element: <Register />
            },
            {
                path: "payment",
                element: <PayAsGuest />
            },
            // {
            //     path: "account-application",
            //     element: <ApplyForAccount />
            // },
            {
                path: "new-customer",
                element: <NewCustomer />
            },
            {
                path: 'login',
                element: <LoginLayout />,
            },
            {
                path: 'forget-password',
                element: <ForgetPassword />,
            },
            {
                path: '404',
                element: <PageNotFound />
            },

            {
                path: "admin",
                children: [
                    {
                        path: "accounts",
                        children: [{
                            path: "",
                            element: (
                                <ProtectedAdminRoutes>
                                    <Accounts />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "users",
                            element: (
                                <ProtectedAdminRoutes>
                                    <ListUsers />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "users/create",
                            element: (
                                <ProtectedAdminRoutes>
                                    <CreateUser />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: ":account_id",
                            element: (
                                <ProtectedAdminRoutes>
                                    <AccountDetails />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "inquiries",
                            element: (
                                <ProtectedAdminRoutes>
                                    <Inquiries />
                                </ProtectedAdminRoutes>
                            ),
                        },
                        {
                            path: "account-applications",
                            element: (
                                <ProtectedAdminRoutes>
                                    <AccountApplications />
                                </ProtectedAdminRoutes>
                            ),
                        },
                        {
                            path: "credit-applications",
                            element: (
                                <ProtectedAdminRoutes>
                                    <CreditApplications />
                                </ProtectedAdminRoutes>
                            ),
                        },
                        {
                            path: "orders",
                            element: (
                                <ProtectedAdminRoutes>
                                    <FuelOrder />
                                </ProtectedAdminRoutes>
                            ),
                        },
                        {
                            path: "manage-app-settings",
                            element: (
                                <ProtectedAdminRoutes>
                                    <ManageAppSetting />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "notification-configs",
                            element: (
                                <ProtectedAdminRoutes>
                                    <NotificationConfigComponent />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "promotional-images",
                            element: (
                                <ProtectedAdminRoutes>
                                    <PromotionalImages />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "settings",
                            element: (
                                <ProtectedAdminRoutes>
                                    <ManageContent />
                                </ProtectedAdminRoutes>
                            )
                        },
                        {
                            path: "manage-configs",
                            element: (
                                <ProtectedAdminRoutes>
                                    <ManageConfigs />
                                </ProtectedAdminRoutes>
                            )
                        },
                        ]
                    },
                    {
                        path: "profile",
                        children: [
                            {
                                path: "",
                                element: (
                                    <ProtectedAdminRoutes>
                                        <AdminProfile />
                                    </ProtectedAdminRoutes>
                                )
                            },
                            {
                                path: "change-password",
                                element: (
                                    <ProtectedAdminRoutes>
                                        <ChangePassword />
                                    </ProtectedAdminRoutes>
                                )
                            },
                        ],
                    },
                    {
                        path: "users",
                        children: [
                            {
                                path: "",
                                element: (
                                    <ProtectedAdminRoutes>
                                        <ListUsers />
                                    </ProtectedAdminRoutes>
                                )
                            },
                            {
                                path: "list",
                                element: (
                                    <ProtectedAdminRoutes>
                                        <ListUsers />
                                    </ProtectedAdminRoutes>
                                )
                            },
                            {
                                path: "create",
                                element: (
                                    <ProtectedAdminRoutes>
                                        <CreateUser />
                                    </ProtectedAdminRoutes>
                                )
                            },
                        ],
                    },
                ]
            },
            {
                path: "accounts",
                children: [{
                    path: "",
                    element: (
                        <ProtectedUserRoutes>
                            <UserAccounts >
                                <></>
                            </UserAccounts>
                        </ProtectedUserRoutes>
                    )
                },
                {
                    path: ":account_id",
                    children: [
                        {
                            path: "",
                            element: (
                                <ProtectedUserRoutes>
                                    <UserAccounts >
                                        <Overview />
                                    </UserAccounts>
                                </ProtectedUserRoutes>
                            )
                        },
                        // {
                        //     path: "documents",
                        //     element: (
                        //         <ProtectedUserRoutes>
                        //             <UserAccounts >
                        //                 <Documents />
                        //             </UserAccounts>
                        //         </ProtectedUserRoutes>
                        //     )
                        // },
                        {
                            path: "order-fuel",
                            element: (
                                <ProtectedUserRoutes>
                                    <UserAccounts >
                                        <OrderFuel />
                                    </UserAccounts>
                                </ProtectedUserRoutes>
                            )
                        },
                        {
                            path: "payment",
                            element: (
                                <ProtectedUserRoutes>
                                    <UserAccounts >
                                        <Payment />
                                    </UserAccounts>
                                </ProtectedUserRoutes>
                            )
                        },
                        {
                            path: "records",
                            element: (
                                <ProtectedUserRoutes>
                                    <UserAccounts >
                                        <Records />
                                    </UserAccounts>
                                </ProtectedUserRoutes>
                            )
                        },
                        {
                            path: "products",
                            element: (
                                <ProtectedUserRoutes>
                                    <UserAccounts >
                                        <Drops />
                                    </UserAccounts>
                                </ProtectedUserRoutes>
                            )
                        },
                        {
                            path: "records/documents/view-pdf",
                            element: (
                                <ProtectedUserRoutes>
                                    <UserAccounts>
                                        <ViewPdf />
                                    </UserAccounts>
                                </ProtectedUserRoutes>
                            )
                        },
                        // {
                        //     path: "status",
                        //     element: (
                        //         <ProtectedUserRoutes>
                        //             <UserAccounts >
                        //                 <Status />
                        //             </UserAccounts>
                        //         </ProtectedUserRoutes>
                        //     )
                        // },
                        // {
                        //     path: "deliveries",
                        //     element: (
                        //         <ProtectedUserRoutes>
                        //             <UserAccounts >
                        //                 <Deliveries />
                        //             </UserAccounts>
                        //         </ProtectedUserRoutes>
                        //     )
                        // },
                        // {
                        //     path: "transactions",
                        //     element: (
                        //         <ProtectedUserRoutes>
                        //             <UserAccounts >
                        //                 <Transactions />
                        //             </UserAccounts>
                        //         </ProtectedUserRoutes>
                        //     )
                        // },
                    ]
                },
                ],
            },
            {
                path: "contact",
                element: (
                    <ProtectedUserRoutes>
                        <Contact />
                    </ProtectedUserRoutes>
                )
            },
            {
                path: "residential-credit",
                element: (
                    <ProtectedUserRoutes>
                        <ResidentialApplication />
                    </ProtectedUserRoutes>
                )
            },
            {
                path: "profile",
                children: [
                    {
                        path: "",
                        element: (
                            <ProtectedUserRoutes>
                                <UserProfile />
                            </ProtectedUserRoutes>
                        )
                    },
                    {
                        path: "change-password",
                        element: (
                            <ProtectedUserRoutes>
                                <ChangePassword />
                            </ProtectedUserRoutes>
                        )
                    },
                ]
            },
            {
                path: "*",
                element: <Navigate to="404" replace />
            }
        ],
    },
];